import React, { useEffect, useState } from "react";
import Inputbox from "../../Components/Inputbox";
import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import * as Yup from "yup";
import {
  AddDeliveryMode,
  DeleteDeliveryMode,
  GetDeliveryMode,
} from "../../../api/helper";
import { useSelector } from "react-redux";
import { ShowToast } from "../../../helpers/ToastService";
import { Box, Modal } from "@mui/material";
import DeleteModal from "../Components/DeleteModal";

const validationSchema = Yup.object().shape({
  name: Yup.string().required("Name is required"),
});
function DeliveryMode({ GetTabStatus }) {
  const [showModal, setShowModal] = useState(false);
  const [addressData, setaddressData] = useState([]);
  const profiledata = useSelector((state) => state?.cookies?.userDetails);
  const [confirmdeletemodal, setconfirmdeletemodal] = useState(false);
  const [deleteId, setdeleteId] = useState(null);

  const {
    register,
    handleSubmit,
    clearErrors,
    reset,
    formState: { errors },
  } = useForm({
    resolver: yupResolver(validationSchema),
  });

  const onSubmit = async (data) => {
    data.agencyId = profiledata?._id;
    setShowModal(false);
    try {
      const response = await AddDeliveryMode(data);
      ShowToast(response?.data?.message);
      reset();
      FetchDatalist();
      GetTabStatus();
    } catch (error) {
      console.log(error);
    }
  };
  const handleDelete = (id) => {
    setdeleteId(id);
    setconfirmdeletemodal(true);
  };

  const confirmDelete = async () => {
    setconfirmdeletemodal(false);

    try {
      const response = await DeleteDeliveryMode(`?id=${deleteId}`);
      if (response?.data?.success) {
        ShowToast(response?.data?.message);
        FetchDatalist();
        GetTabStatus();
      } else {
        ShowToast("Error: Unable to delete address.");
      }
    } catch (error) {
      console.error("Delete operation failed:", error);
      ShowToast("An error occurred while deleting the address.");
    }
  };

  const FetchDatalist = async () => {
    try {
      const response = await GetDeliveryMode(`?id=${profiledata?._id}`);
      setaddressData(response?.data?.data || []);
    } catch (error) {
      console.log(error);
    }
  };
  useEffect(() => {
    FetchDatalist();
  }, []);
  const openModal = () => setShowModal(true);
  const closeModal = () => setShowModal(false);
  const modalStyle = {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    width: "50%",
    height: "90vh",
    overflowY: "auto", // Set a fixed height for the modal
    bgcolor: "background.paper",
    boxShadow: 24,
    p: 4,
    borderRadius: 4,
    outline: "none",
    // Enable vertical scrolling
  };
  return (
    <div
      style={{
        width: "100%",
        alignItems: "center",
        justifyItems: "center",
        marginBottom: 20,
      }}
    >
      <div
        style={{
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          width: "100%",
        }}
      >
        <h1>Delivery Mode</h1>
        <div
          style={{
            backgroundColor: "#bc9c22",
            color: "white",
            padding: 10,
            borderRadius: 6,
          }}
          onClick={openModal}
        >
          Add Delivery Mode
        </div>
      </div>

      <div style={{ overflowX: "auto", width: "100%", marginTop: 30 }}>
        <table className="table">
          <thead>
            <tr>
              <th>Name</th>
              <th>Definition</th>
              <th>Action</th>
            </tr>
          </thead>
          <tbody>
            {addressData.length === 0 ? (
              <tr>
                <td
                  colSpan="11"
                  style={{ textAlign: "center", padding: "20px" }}
                >
                  No DeliveryMode found.
                </td>
              </tr>
            ) : (
              addressData.map((row, index) => (
                <tr key={index} style={tableRowStyle}>
                  <td style={tableCellStyle}>{row?.name}</td>
                  <td style={tableCellStyle}>{row?.description}</td>
                  <td style={tableCellStyle}>
                    <button
                      className="action_icon_btn"
                      title="Edit"
                      onClick={() => handleDelete(row._id)}
                    >
                      <i class="fas fa-trash-alt" style={{ color: "black" }} />
                    </button>
                  </td>
                </tr>
              ))
            )}
          </tbody>
        </table>
      </div>

      <Modal
        open={showModal}
        onClose={closeModal}
        aria-labelledby="modal-title"
      >
        <Box sx={modalStyle}>
          <form
            onSubmit={handleSubmit(onSubmit)}
            style={{
              width: "100%",
              alignItems: "center",
              justifyItems: "center",
              marginBottom: 20,
            }}
          >
            <h1 style={{ textAlign: "left" }}>New Delivery Mode</h1>
            <div
              style={{
                alignItems: "center",
                justifyContent: "center",
                width: "100%",
              }}
            >
              <Inputbox
                label="Name"
                className="Custom_input"
                type="text"
                placeholder="Enter Delivery Mode Name"
                name="name"
                register={register}
              />
              <p style={{ color: "red", textAlign: "left" }}>
                {errors.name?.message}
              </p>
              <Inputbox
                label="Definition"
                type="text"
                placeholder="Enter Delivery Mode Definition"
                name="description"
                className="Custom_input"
                register={register}
              />
              <p style={{ color: "red", textAlign: "left" }}>
                {errors.name?.message}
              </p>
              <button
                type="submit"
                style={{
                  marginBottom: 20,
                  marginTop: 20,
                  alignSelf: "center",
                  width: "100%",
                  height: "50px",
                }}
                className="Save_buttonnn"
              >
                Submit
              </button>
              <p className="text-center">
                Please make surethe service name is unique
              </p>
            </div>
          </form>
        </Box>
      </Modal>
        {confirmdeletemodal && (
              <DeleteModal
                name="Delivery Modes"
                onClose={() => setconfirmdeletemodal(false)}
                onConfirm={confirmDelete}
              />
            )}
    </div>
  );
}

const tableHeaderStyle = {
  padding: "10px",
  borderBottom: "2px solid #ddd",
  textAlign: "left",
  fontWeight: "bold",
  backgroundColor: "#f4f4f4",
};

const tableCellStyle = {
  padding: "8px",
  borderBottom: "1px solid #ddd",
};

const tableRowStyle = {
  borderBottom: "1px solid #ddd",
};

const deleteButtonStyle = {
  backgroundColor: "red",
  color: "white",
  border: "none",
  borderRadius: "4px",
  padding: "5px 10px",
  cursor: "pointer",
};

export default DeliveryMode;
